import { render } from "./AlternativesImportPage.vue?vue&type=template&id=2769530f&scoped=true&ts=true"
import script from "./AlternativesImportPage.vue?vue&type=script&lang=ts"
export * from "./AlternativesImportPage.vue?vue&type=script&lang=ts"

import "./AlternativesImportPage.vue?vue&type=style&index=0&id=2769530f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2769530f"]])

export default __exports__